<template>
  <div id="app">
    <Header v-if="!isMobile" style="z-index: 1000" />
    <MobileHeader v-if="isMobile" />
    <main class="main-content" :style="isMobile ? 'height: calc(100vh - 1.51rem);' : 'height: calc(100vh - 1.97rem);'">
      <router-view />
    </main>
  </div>
</template>
<script setup>
import Header from "./components/Header.vue";
import MobileHeader from "./components/mobileHeader.vue";
import { onMounted } from "vue";
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const isMobile = ref(false);
function isMobileDevice() {
  let clientWidth = document.documentElement.clientWidth;
  const userAgent = navigator.userAgent.toLowerCase();
  isMobile.value = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|windows phone|phone|webos|kindle|tablet/i.test(userAgent) || clientWidth <= 750;
}
onMounted(() => {
  isMobileDevice();
  window.addEventListener("resize", isMobileDevice);
});
</script>
<style lang="scss">
body,
th,
td {
  margin: 0;
  padding: 0;
}

* {
  margin: 0;
}

image {
  display: block;
}

a {
  text-decoration: none;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  height: calc(100vh - 1.97rem);
}

page {
  background-color: #f4f4f4;
}

.pointer {
  cursor: pointer;
}
.default {
  cursor: default;
}

::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.ai {
  align-items: center;
}

.jcc {
  justify-content: center;
}

.jcs {
  justify-content: space-between;
}
@font-face {
  font-family: "SourceHanSansSC-Bold";
  src: url(../src/assets/font/SourceHanSansSC-Bold-2.otf);
}
@font-face {
  font-family: "SourceHanSansSC-Regular";
  src: url(../src/assets/font/SourceHanSansSC-Regular-2.otf);
}
@font-face {
  font-family: "SourceHanSansSC-Heavy";
  src: url(../src/assets/font/SourceHanSansSC-Heavy-2.otf);
}
</style>
